import { render, staticRenderFns } from "./productionCostCard.vue?vue&type=template&id=5f0e0458&scoped=true"
import script from "./productionCostCard.vue?vue&type=script&lang=js"
export * from "./productionCostCard.vue?vue&type=script&lang=js"
import style0 from "./productionCostCard.vue?vue&type=style&index=0&id=5f0e0458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e0458",
  null
  
)

export default component.exports